import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { updateGTMConsentStatus } from './utils'

const GTM_TYPE = 'gtm/consentUpdate'

const CookieCatBanner = ({ app, isGoogleAnalyticsEnabled, locale, theme }) => {
  const dispatch = useDispatch()

  let onBannerClose = null

  const initializeCookieCat = () => {
    if (window.CookieCat?.init) {
      window.CookieCat.init({
        app,
        locale,
        theme
      }, handleConsentUpdate)
      window.CookieCat?.onAccept(handleConsentUpdate)
    }
  }

  const handleConsentUpdate = data => {
    if (isGoogleAnalyticsEnabled) {
      const payload = updateGTMConsentStatus(data)
      dispatch({ payload, type: GTM_TYPE })
    }
    if (typeof onBannerClose === 'function') {
      onBannerClose()
    }
    onBannerClose = null
  }

  useEffect(() => {
    initializeCookieCat()
  }, [])

  window.showCookieBanner = onClose => {
    if (window.CookieCat) {
      window.CookieCat.showBanner()
      onBannerClose = onClose
    }
  }

  return null
}

CookieCatBanner.propTypes = {
  app: PropTypes.string.isRequired,
  isGoogleAnalyticsEnabled: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired
}

export default CookieCatBanner
